import { differenceInMonths } from "date-fns";
import moment from "moment";

const aviationAllTimeValues = [
  {
    behaviourKey: "EFFICIENT_FLIGHT",
    behaviourName: "Efficient Flight",
    behaviourAcronym: "EF",
    behaviourPosition: 4,
    countEventsPerformedPreSignol: 151637,
    countEventsPerformedPostSignol: 182085,
    totalFuelSavingKgPreSignol: 130444710,
    totalFuelSavingKgPostSignol: 215532260,
    avgNetFuelSavingKgPreSignol: {
      value: 658,
      standardError68: 3,
      standardError95: 6,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.658,
      standardError68: 0.003,
      standardError95: 0.006,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 966,
      standardError68: 4,
      standardError95: 8,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 1,
      standardError68: 0.004,
      standardError95: 0.008,
    },
    avgNetFuelSavingChangeKg: {
      value: 308,
      standardError68: 7,
      standardError95: 14,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.3,
      standardError68: 0.007,
      standardError95: 0.014,
    },
  },
  {
    behaviourKey: "Optimal Discretionary Fuel Load",
    behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
    behaviourAcronym: "ODFL",
    behaviourPosition: 3,
    countEventsPerformedPreSignol: 69032,
    countEventsPerformedPostSignol: 89984,
    totalFuelSavingKgPreSignol: -4772048.5,
    totalFuelSavingKgPostSignol: 17464692,
    avgNetFuelSavingKgPreSignol: {
      value: -36,
      standardError68: 1,
      standardError95: 2,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: -0.036,
      standardError68: 0.001,
      standardError95: 0.002,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 10,
      standardError68: 1,
      standardError95: 2,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.01,
      standardError68: 0.001,
      standardError95: 0.002,
    },
    avgNetFuelSavingChangeKg: {
      value: 46,
      standardError68: 2,
      standardError95: 4,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.046,
      standardError68: 0.002,
      standardError95: 0.004,
    },
  },
  {
    behaviourKey: "REDUCED_ENGINE_TAXI_IN",
    behaviourName: "Reduced Engine Taxi In",
    behaviourAcronym: "RETI",
    behaviourPosition: 2,
    countEventsPerformedPreSignol: 127313,
    countEventsPerformedPostSignol: 213251,
    totalFuelSavingKgPreSignol: 11979573,
    totalFuelSavingKgPostSignol: 16417967,
    avgNetFuelSavingKgPreSignol: {
      value: 21,
      standardError68: 1,
      standardError95: 2,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.021,
      standardError68: 0.001,
      standardError95: 0.002,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 54,
      standardError68: 1,
      standardError95: 2,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.054,
      standardError68: 0.001,
      standardError95: 0.002,
    },
    avgNetFuelSavingChangeKg: {
      value: 33,
      standardError68: 2,
      standardError95: 4,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.02,
      standardError68: 0.07,
      standardError95: 0.13,
    },
  },
  {
    behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
    behaviourName: "Reduced Engine Taxi Out",
    behaviourAcronym: "RETO",
    behaviourPosition: 1,
    countEventsPerformedPreSignol: 37076,
    countEventsPerformedPostSignol: 38796,
    totalFuelSavingKgPreSignol: 2318921.2,
    totalFuelSavingKgPostSignol: 2101215.8,
    avgNetFuelSavingKgPreSignol: {
      value: 13,
      standardError68: 1,
      standardError95: 2,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.013,
      standardError68: 0.001,
      standardError95: 0.002,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 41,
      standardError68: 2,
      standardError95: 4,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.041,
      standardError68: 0.002,
      standardError95: 0.004,
    },
    avgNetFuelSavingChangeKg: {
      value: 28,
      standardError68: 3,
      standardError95: 6,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.028,
      standardError68: 0.003,
      standardError95: 0.006,
    },
  },
  {
    behaviourKey: "DELAYED_FLAPS_APPROACH",
    behaviourName: "Delayed Flaps Approach",
    behaviourAcronym: "DFA",
    behaviourPosition: 5,
    countEventsPerformedPreSignol: 32076,
    countEventsPerformedPostSignol: 32796,
    totalFuelSavingKgPreSignol: 1318921.2,
    totalFuelSavingKgPostSignol: 1101215.8,
    avgNetFuelSavingKgPreSignol: {
      value: 15,
      standardError68: 2,
      standardError95: 5,
    },
    avgNetFuelSavingTonnesPreSignol: {
      value: 0.015,
      standardError68: 0.002,
      standardError95: 0.005,
    },
    avgNetFuelSavingKgPostSignol: {
      value: 20,
      standardError68: 3,
      standardError95: 6,
    },
    avgNetFuelSavingTonnesPostSignol: {
      value: 0.02,
      standardError68: 0.003,
      standardError95: 0.006,
    },
    avgNetFuelSavingChangeKg: {
      value: 15,
      standardError68: 4,
      standardError95: 8,
    },
    avgNetFuelSavingChangeTonnes: {
      value: 0.015,
      standardError68: 0.004,
      standardError95: 0.008,
    },
  },
];

const aviationMonthyValues = {
  [moment.utc().subtract(1, "month").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 151637,
      countEventsPerformedPostSignol: 7696,
      totalFuelSavingKgPreSignol: 130444710,
      totalFuelSavingKgPostSignol: 11519850,
      avgNetFuelSavingKgPreSignol: {
        value: 658,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.658,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1092,
        standardError68: 5,
        standardError95: 10,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1.1,
        standardError68: 0.005,
        standardError95: 0.01,
      },
      avgNetFuelSavingChangeKg: {
        value: 434,
        standardError68: 8,
        standardError95: 16,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.4,
        standardError68: 0.008,
        standardError95: 0.016,
      },
    },
    {
      behaviourKey: "Optimal Discretionary Fuel Load",
      behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 69032,
      countEventsPerformedPostSignol: 7721,
      totalFuelSavingKgPreSignol: -4772048.5,
      totalFuelSavingKgPostSignol: 1382757.9,
      avgNetFuelSavingKgPreSignol: {
        value: -36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: -0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 9,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.009,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 45,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.045,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 127313,
      countEventsPerformedPostSignol: 9420,
      totalFuelSavingKgPreSignol: 11979573,
      totalFuelSavingKgPostSignol: 1027099.94,
      avgNetFuelSavingKgPreSignol: {
        value: 21,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.021,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 52,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.052,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingChangeKg: {
        value: 31,
        standardError68: 4,
        standardError95: 8,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.031,
        standardError68: 0.004,
        standardError95: 0.008,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1116,
      totalFuelSavingKgPreSignol: 2318921.2,
      totalFuelSavingKgPostSignol: 71386.59,
      avgNetFuelSavingKgPreSignol: {
        value: 13,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.013,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 39,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.039,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 26,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.026,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
    {
      behaviourKey: "DELAYED_FLAPS_APPROACH",
      behaviourName: "Delayed Flaps Approach",
      behaviourAcronym: "DFA",
      behaviourPosition: 5,
      countEventsPerformedPreSignol: 32076,
      countEventsPerformedPostSignol: 32796,
      totalFuelSavingKgPreSignol: 1318921.2,
      totalFuelSavingKgPostSignol: 1101215.8,
      avgNetFuelSavingKgPreSignol: {
        value: 15,
        standardError68: 2,
        standardError95: 5,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.015,
        standardError68: 0.002,
        standardError95: 0.005,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 20,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.02,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingChangeKg: {
        value: 15,
        standardError68: 4,
        standardError95: 8,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.015,
        standardError68: 0.004,
        standardError95: 0.008,
      },
    },
  ],
  [moment.utc().subtract(2, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 151637,
      countEventsPerformedPostSignol: 6394,
      totalFuelSavingKgPreSignol: 130444710,
      totalFuelSavingKgPostSignol: 7614700,
      avgNetFuelSavingKgPreSignol: {
        value: 658,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.658,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1010,
        standardError68: 9,
        standardError95: 18,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1,
        standardError68: 0.009,
        standardError95: 0.018,
      },
      avgNetFuelSavingChangeKg: {
        value: 352,
        standardError68: 12,
        standardError95: 24,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.4,
        standardError68: 0.012,
        standardError95: 0.024,
      },
    },
    {
      behaviourKey: "Optimal Discretionary Fuel Load",
      behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 69032,
      countEventsPerformedPostSignol: 6399,
      totalFuelSavingKgPreSignol: -4772048.5,
      totalFuelSavingKgPostSignol: 789759.44,
      avgNetFuelSavingKgPreSignol: {
        value: -36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: -0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 6,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.006,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 40,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.04,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 127313,
      countEventsPerformedPostSignol: 5846,
      totalFuelSavingKgPreSignol: 11979573,
      totalFuelSavingKgPostSignol: 632349.8,
      avgNetFuelSavingKgPreSignol: {
        value: 21,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.021,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 49,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.049,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 28,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.028,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1116,
      totalFuelSavingKgPreSignol: 2318921.2,
      totalFuelSavingKgPostSignol: 72540,
      avgNetFuelSavingKgPreSignol: {
        value: 13,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.013,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 23,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.023,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
  ],
  [moment.utc().subtract(3, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 151637,
      countEventsPerformedPostSignol: 8284,
      totalFuelSavingKgPreSignol: 130444710,
      totalFuelSavingKgPostSignol: 9048000,
      avgNetFuelSavingKgPreSignol: {
        value: 658,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.658,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1000,
        standardError68: 8,
        standardError95: 16,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1,
        standardError68: 0.008,
        standardError95: 0.016,
      },
      avgNetFuelSavingChangeKg: {
        value: 342,
        standardError68: 11,
        standardError95: 22,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.3,
        standardError68: 0.011,
        standardError95: 0.022,
      },
    },
    {
      behaviourKey: "Optimal Discretionary Fuel Load",
      behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 69032,
      countEventsPerformedPostSignol: 6595,
      totalFuelSavingKgPreSignol: -4772048.5,
      totalFuelSavingKgPostSignol: 1187336.9,
      avgNetFuelSavingKgPreSignol: {
        value: -36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: -0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 3,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.003,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 39,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.039,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 127313,
      countEventsPerformedPostSignol: 7535,
      totalFuelSavingKgPreSignol: 11979573,
      totalFuelSavingKgPostSignol: 757169.4,
      avgNetFuelSavingKgPreSignol: {
        value: 21,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.021,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 46,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.046,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 25,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.025,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 930,
      totalFuelSavingKgPreSignol: 2318921.2,
      totalFuelSavingKgPostSignol: 59949.555,
      avgNetFuelSavingKgPreSignol: {
        value: 13,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.013,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 31,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.031,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 18,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.018,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
  ],
  [moment.utc().subtract(4, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 151637,
      countEventsPerformedPostSignol: 8088,
      totalFuelSavingKgPreSignol: 130444710,
      totalFuelSavingKgPostSignol: 10281050,
      avgNetFuelSavingKgPreSignol: {
        value: 658,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.658,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1049,
        standardError68: 13,
        standardError95: 26,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1,
        standardError68: 0.013,
        standardError95: 0.026,
      },
      avgNetFuelSavingChangeKg: {
        value: 391,
        standardError68: 16,
        standardError95: 32,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.4,
        standardError68: 0.016,
        standardError95: 0.032,
      },
    },
    {
      behaviourKey: "Optimal Discretionary Fuel Load",
      behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 69032,
      countEventsPerformedPostSignol: 7334,
      totalFuelSavingKgPreSignol: -4772048.5,
      totalFuelSavingKgPostSignol: 1370995.6,
      avgNetFuelSavingKgPreSignol: {
        value: -36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: -0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: -5,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: -0.005,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 31,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.031,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 127313,
      countEventsPerformedPostSignol: 9234,
      totalFuelSavingKgPreSignol: 11979573,
      totalFuelSavingKgPostSignol: 969022,
      avgNetFuelSavingKgPreSignol: {
        value: 21,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.021,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 40,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.04,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 19,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.019,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 1674,
      totalFuelSavingKgPreSignol: 2318921.2,
      totalFuelSavingKgPostSignol: 107809.59,
      avgNetFuelSavingKgPreSignol: {
        value: 13,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.013,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 28,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.028,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 15,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.015,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
  ],
  [moment.utc().subtract(5, "months").format("YYYY/MM/DD")]: [
    {
      behaviourKey: "EFFICIENT_FLIGHT",
      behaviourName: "Efficient Flight",
      behaviourAcronym: "EF",
      behaviourPosition: 4,
      countEventsPerformedPreSignol: 151637,
      countEventsPerformedPostSignol: 9219,
      totalFuelSavingKgPreSignol: 130444710,
      totalFuelSavingKgPostSignol: 11977250,
      avgNetFuelSavingKgPreSignol: {
        value: 658,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.658,
        standardError68: 0.003,
        standardError95: 0.006,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 1135,
        standardError68: 9,
        standardError95: 18,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 1.1,
        standardError68: 0.009,
        standardError95: 0.018,
      },
      avgNetFuelSavingChangeKg: {
        value: 477,
        standardError68: 12,
        standardError95: 24,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.5,
        standardError68: 0.012,
        standardError95: 0.024,
      },
    },
    {
      behaviourKey: "Optimal Discretionary Fuel Load",
      behaviourName: "OPTIMAL_DISCRETIONARY_FUEL_LOAD",
      behaviourAcronym: "ODFL",
      behaviourPosition: 3,
      countEventsPerformedPreSignol: 69032,
      countEventsPerformedPostSignol: 8103,
      totalFuelSavingKgPreSignol: -4772048.5,
      totalFuelSavingKgPostSignol: 1941332.9,
      avgNetFuelSavingKgPreSignol: {
        value: -36,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: -0.036,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: -10,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: -0.01,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingChangeKg: {
        value: 26,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.026,
        standardError68: 0.002,
        standardError95: 0.004,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_IN",
      behaviourName: "Reduced Engine Taxi In",
      behaviourAcronym: "RETI",
      behaviourPosition: 2,
      countEventsPerformedPreSignol: 127313,
      countEventsPerformedPostSignol: 8862,
      totalFuelSavingKgPreSignol: 11979573,
      totalFuelSavingKgPostSignol: 889508.5,
      avgNetFuelSavingKgPreSignol: {
        value: 21,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.021,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 36,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.036,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 15,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.015,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
    {
      behaviourKey: "REDUCED_ENGINE_TAXI_OUT",
      behaviourName: "Reduced Engine Taxi Out",
      behaviourAcronym: "RETO",
      behaviourPosition: 1,
      countEventsPerformedPreSignol: 37076,
      countEventsPerformedPostSignol: 930,
      totalFuelSavingKgPreSignol: 2318921.2,
      totalFuelSavingKgPostSignol: 59949.58,
      avgNetFuelSavingKgPreSignol: {
        value: 13,
        standardError68: 1,
        standardError95: 2,
      },
      avgNetFuelSavingTonnesPreSignol: {
        value: 0.013,
        standardError68: 0.001,
        standardError95: 0.002,
      },
      avgNetFuelSavingKgPostSignol: {
        value: 25,
        standardError68: 2,
        standardError95: 4,
      },
      avgNetFuelSavingTonnesPostSignol: {
        value: 0.025,
        standardError68: 0.002,
        standardError95: 0.004,
      },
      avgNetFuelSavingChangeKg: {
        value: 12,
        standardError68: 3,
        standardError95: 6,
      },
      avgNetFuelSavingChangeTonnes: {
        value: 0.012,
        standardError68: 0.003,
        standardError95: 0.006,
      },
    },
  ],
};

export const getBehaviourFuelSavingVsPreSignolRespAviation = (
  teamId,
  startDate,
  endDate,
) => {
  let data = aviationAllTimeValues;
  if (startDate || endDate) {
    let monthsAgo =
      differenceInMonths(new Date(), new Date(endDate || startDate)) + 1;
    monthsAgo = monthsAgo > 5 ? 5 : monthsAgo; // just return the fifth month for any months further back in time
    data =
      aviationMonthyValues[
        moment.utc().subtract(monthsAgo, "months").format("YYYY/MM/DD")
      ];
  }
  return data;
};
